import tinycolor from 'tinycolor2';

// Source of truth for the default brand colour; --primary and --ring in src/index.css must match it
// (defaultBrandColor.test.ts enforces it)
export const DEFAULT_BRAND_COLOR = '#ff5800';

const { h, s, l } = tinycolor(DEFAULT_BRAND_COLOR).toHsl();

export const DEFAULT_PRIMARY_HSL = `${h.toFixed(1)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
